import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/auth-section/auth-service/auth.service';
import { PatientsService } from 'src/app/patient-section/patient-service/patients.service';
///import { ConfirmationService } from 'primeng/api/public_api';
import { PatientlocalService } from 'src/app/patient-section/patient-service/patientlocal.service';
import { HospitalService } from '../hospital.service';
import { ConfirmationService } from "primeng/api";

@Component({
  selector: 'app-hospital',
  templateUrl: './hospital.component.html',
  styleUrls: ['./hospital.component.css'],
  providers:[ConfirmationService]
})
export class HospitalComponent implements OnInit {
 
  isData = true;
  token: string;
  filter;
  isSearch = false;
  searchQuery = null;
  hosData = [];
  id: string;
  config: { itemsPerPage: number; currentPage: number; totalItems: number };
  page: number = 1;
  totalItems: number = 0;
  allTotal: number;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private hospitalService: HospitalService,
   private conformationService: ConfirmationService,
    private patientLocalService: PatientlocalService
  ) {}

  ngOnInit() {
    this.authService.authDataSubject.subscribe(res => {
      this.token = res._token;
    });
    this.getHospital("1");
    this.initConfig();
  }
  onAddHospital() {
    this.router.navigate(["register"], {
      relativeTo: this.activatedRoute
    });
  }
  getHospital(page) {
    this.hospitalService.getHospitalFromDb(this.token, page).subscribe(res => {
       this.hosData = res.patData;
this.isData=res.patData.length>0
      this.page = +res.page;
     
      this.totalItems = res.total;
      this.initConfig();
    });
  }
  onHospitalClicked(id) {
    console.log("clicked"+ id)
    this.router.navigate(["doctors"], {
      relativeTo: this.activatedRoute,
      queryParams: { id: id }
    });
  }

  onUpdateHospital(event, id) {
    event.stopPropagation();
   
    this.router.navigate(["update"], {
      relativeTo: this.activatedRoute,
      queryParams: { id: id }
    });
  }
  onDeleteHospital(event, id,index) {
    this.conformationService.confirm({
      message: "Are you sure that you want to perform this action?",
      accept: () => {
        this.hospitalService
          .deleteHospital(id, this.token)
          .subscribe(res => {
            this.hosData.splice(index, 1);
          });
        //Actual logic to perform a confirmation
      }
    });
    event.stopPropagation();
  }
  initConfig() {
    this.config = {
      itemsPerPage: 10,
      currentPage: this.page,
      totalItems: this.totalItems
    };
  }
  pageChanged(event) {
    this.config.currentPage = event;
   /* if (this.isSearch && this.searchQuery) {
      this.serachPatients(this.searchQuery, this.config.currentPage);
    } else {*/
      this.getHospital(this.config.currentPage);
  //  }
  }
  /*onSearchChange(value) {
    if (value) {
      this.searchQuery = value;
      this.serachPatients(value, 1);
      this.isSearch = true;
    } else {
      this.patData = this.patientLocalService.getPatients();
      this.page = 1;
      this.isSearch = false;
      this.totalItems = this.allTotal;
      this.searchQuery = null;
    }
  }*/
/*  serachPatients(value, pagNo) {
    this.patientsService
      .onSearchPatient(value, this.token, pagNo)
      .subscribe(res => {
        this.patData = res.patData;

        this.page = +res.page;

        this.totalItems = res.total;
        this.initConfig();
      });
  }*/



  onAddHospitalImages(event, id,index){
    event.stopPropagation();
   
    this.router.navigate(["addimages"], {
      relativeTo: this.activatedRoute,
      queryParams: { id: id }
    });
  }


}